import { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';

const CATEGORIES = [
  { id: 'all', label: '全部', icon: 'ri-apps-line', color: '#00FFCC' },
  { id: 'robot', label: '超级机器人', icon: 'ri-robot-line', color: '#FF6B35' },
  { id: 'meta', label: '元宇宙装备', icon: 'ri-glasses-2-line', color: '#A855F7' },
  { id: 'wearable', label: '智能穿戴', icon: 'ri-device-line', color: '#FFD700' },
  { id: 'digital', label: '数字资产', icon: 'ri-nft-line', color: '#FF6B9D' },
];

const ROBOTS = [
  {
    id: 'r1',
    brand: '宇树科技',
    brandEn: 'Unitree',
    model: 'H1 Pro',
    category: 'robot',
    price: '¥899,000',
    priceUSD: '$125,000',
    badge: '🔥 最畅销',
    badgeColor: '#FF6B35',
    img: 'https://public.readdy.ai/ai/img_res/83bac02537b241e0c4677b3412ccdbd2.jpg',
    desc: '宇树H1 Pro人形机器人，身高1.8m，负重30kg，可完成后空翻、街舞等高难度动作，搭载最新神经网络控制系统',
    specs: ['身高 1.8m', '负重 30kg', '续航 2h', '防水 IP67'],
    link: 'https://www.unitree.com/h1',
    rating: 4.9,
    reviews: 128,
    inStock: true,
    isNew: true,
  },
  {
    id: 'r2',
    brand: '宇树科技',
    brandEn: 'Unitree',
    model: 'G1',
    category: 'robot',
    price: '¥299,000',
    priceUSD: '$41,500',
    badge: '⚡ 新品',
    badgeColor: '#00FFCC',
    img: 'https://readdy.ai/api/search-image?query=Unitree%20G1%20compact%20humanoid%20robot%20silver%20black%20design%20standing%20clean%20white%20background%20professional%20product%20photography%20ultra%20realistic%208k&width=400&height=500&seq=robot-unitree-g1-001&orientation=portrait',
    desc: '宇树G1紧凑型人形机器人，身高1.27m，适合家庭与商业场景，支持自主导航与物体抓取，价格亲民',
    specs: ['身高 1.27m', '负重 3kg', '续航 2h', '自主导航'],
    link: 'https://www.unitree.com/g1',
    rating: 4.8,
    reviews: 256,
    inStock: true,
    isNew: true,
  },
  {
    id: 'r3',
    brand: '波士顿动力',
    brandEn: 'Boston Dynamics',
    model: 'Atlas',
    category: 'robot',
    price: '¥2,800,000',
    priceUSD: '$390,000',
    badge: '👑 旗舰',
    badgeColor: '#FFD700',
    img: 'https://readdy.ai/api/search-image?query=Boston%20Dynamics%20Atlas%20humanoid%20robot%20black%20white%20design%20athletic%20pose%20dynamic%20movement%20clean%20white%20background%20professional%20product%20photography%20ultra%20realistic%208k&width=400&height=500&seq=robot-atlas-001&orientation=portrait',
    desc: '波士顿动力Atlas，全球最先进的人形机器人，可完成跑酷、翻跟头、搬运重物等复杂任务，液压驱动系统',
    specs: ['身高 1.5m', '负重 11kg', '液压驱动', '全地形'],
    link: 'https://bostondynamics.com/atlas',
    rating: 5.0,
    reviews: 89,
    inStock: false,
    isNew: false,
  },
  {
    id: 'r4',
    brand: '特斯拉',
    brandEn: 'Tesla',
    model: 'Optimus Gen 3',
    category: 'robot',
    price: '¥148,000',
    priceUSD: '$20,000',
    badge: '🚀 预售',
    badgeColor: '#FF6B9D',
    img: 'https://readdy.ai/api/search-image?query=Tesla%20Optimus%20humanoid%20robot%20white%20sleek%20design%20standing%20pose%20futuristic%20clean%20white%20background%20professional%20product%20photography%20ultra%20realistic%208k&width=400&height=500&seq=robot-optimus-001&orientation=portrait',
    desc: '马斯克Tesla Optimus Gen 3，搭载FSD芯片与Dojo超算，具备完整的家务处理能力，量产后将改变人类生活',
    specs: ['身高 1.73m', '负重 20kg', 'FSD芯片', '量产版'],
    link: 'https://www.tesla.com/optimus',
    rating: 4.7,
    reviews: 512,
    inStock: false,
    isNew: true,
  },
  {
    id: 'r5',
    brand: '宇树科技',
    brandEn: 'Unitree',
    model: 'B2-W',
    category: 'robot',
    price: '¥198,000',
    priceUSD: '$27,500',
    badge: '🐕 四足',
    badgeColor: '#00FF88',
    img: 'https://readdy.ai/api/search-image?query=Unitree%20B2%20quadruped%20robot%20dog%20black%20yellow%20industrial%20design%20rugged%20terrain%20clean%20white%20background%20professional%20product%20photography%20ultra%20realistic%208k&width=400&height=500&seq=robot-b2-001&orientation=portrait',
    desc: '宇树B2-W工业级四足机器人，搭载轮腿混合系统，适用于工业巡检、救援、科研等场景，续航超过4小时',
    specs: ['负重 40kg', '续航 4h', '轮腿混合', 'IP67防护'],
    link: 'https://www.unitree.com/b2-w',
    rating: 4.9,
    reviews: 167,
    inStock: true,
    isNew: false,
  },
  {
    id: 'r6',
    brand: '小米',
    brandEn: 'Xiaomi',
    model: 'CyberOne',
    category: 'robot',
    price: '¥599,000',
    priceUSD: '$83,000',
    badge: '🤖 情感AI',
    badgeColor: '#A855F7',
    img: 'https://readdy.ai/api/search-image?query=Xiaomi%20CyberOne%20humanoid%20robot%20black%20sleek%20design%20standing%20pose%20emotional%20AI%20clean%20white%20background%20professional%20product%20photography%20ultra%20realistic%208k&width=400&height=500&seq=robot-cyberone-001&orientation=portrait',
    desc: '小米CyberOne人形机器人，具备情感感知能力，可识别85种环境语义和45种人类情绪，是最具情感温度的机器人',
    specs: ['身高 1.77m', '情感感知', '45种情绪', '自主学习'],
    link: 'https://www.mi.com/cyberone',
    rating: 4.6,
    reviews: 203,
    inStock: true,
    isNew: false,
  },
  {
    id: 'r7',
    brand: 'Figure AI',
    brandEn: 'Figure AI',
    model: 'Figure 02',
    category: 'robot',
    price: '¥1,200,000',
    priceUSD: '$167,000',
    badge: '🧠 GPT驱动',
    badgeColor: '#00FFCC',
    img: 'https://readdy.ai/api/search-image?query=Figure%2002%20humanoid%20robot%20white%20silver%20design%20standing%20pose%20OpenAI%20GPT%20powered%20clean%20white%20background%20professional%20product%20photography%20ultra%20realistic%208k&width=400&height=500&seq=robot-figure02-001&orientation=portrait',
    desc: 'Figure 02搭载OpenAI GPT-5多模态大模型，可进行自然语言交互与复杂任务规划，宝马工厂已批量部署',
    specs: ['GPT-5驱动', '自然语言', '工业级', '宝马认证'],
    link: 'https://www.figure.ai',
    rating: 4.8,
    reviews: 94,
    inStock: false,
    isNew: true,
  },
  {
    id: 'r8',
    brand: 'Agility Robotics',
    brandEn: 'Agility',
    model: 'Digit V5',
    category: 'robot',
    price: '¥980,000',
    priceUSD: '$136,000',
    badge: '📦 物流专用',
    badgeColor: '#FFD700',
    img: 'https://readdy.ai/api/search-image?query=Agility%20Robotics%20Digit%20humanoid%20robot%20blue%20white%20design%20warehouse%20logistics%20clean%20white%20background%20professional%20product%20photography%20ultra%20realistic%208k&width=400&height=500&seq=robot-digit-001&orientation=portrait',
    desc: 'Agility Digit V5专为物流仓储设计，亚马逊仓库已部署超过1000台，可在复杂环境中自主搬运货物',
    specs: ['负重 16kg', '亚马逊认证', '自主导航', '24/7运行'],
    link: 'https://agilityrobotics.com',
    rating: 4.7,
    reviews: 156,
    inStock: true,
    isNew: false,
  },
  {
    id: 'r9',
    brand: '傅利叶智能',
    brandEn: 'Fourier',
    model: 'GR-2',
    category: 'robot',
    price: '¥680,000',
    priceUSD: '$94,500',
    badge: '🏥 医疗级',
    badgeColor: '#FF6B9D',
    img: 'https://readdy.ai/api/search-image?query=Fourier%20GR2%20humanoid%20robot%20white%20medical%20rehabilitation%20design%20standing%20pose%20clean%20white%20background%20professional%20product%20photography%20ultra%20realistic%208k&width=400&height=500&seq=robot-gr2-001&orientation=portrait',
    desc: '傅利叶GR-2医疗康复机器人，专为医疗辅助与康复训练设计，已在全球200家医院部署，帮助患者恢复运动能力',
    specs: ['医疗认证', '康复训练', '40自由度', '力控精准'],
    link: 'https://www.fftai.com',
    rating: 4.9,
    reviews: 78,
    inStock: true,
    isNew: false,
  },
  {
    id: 'r10',
    brand: 'Sanctuary AI',
    brandEn: 'Sanctuary',
    model: 'Phoenix Gen 7',
    category: 'robot',
    price: '¥1,580,000',
    priceUSD: '$219,000',
    badge: '🌟 AGI级',
    badgeColor: '#00FF88',
    img: 'https://readdy.ai/api/search-image?query=Sanctuary%20AI%20Phoenix%20humanoid%20robot%20silver%20white%20design%20standing%20pose%20AGI%20artificial%20general%20intelligence%20clean%20white%20background%20professional%20product%20photography%20ultra%20realistic%208k&width=400&height=500&seq=robot-phoenix-001&orientation=portrait',
    desc: 'Sanctuary Phoenix Gen 7搭载Carbon AGI系统，是目前最接近通用人工智能的机器人，可学习任何新技能',
    specs: ['Carbon AGI', '自主学习', '通用技能', '人类级灵巧'],
    link: 'https://sanctuary.ai',
    rating: 4.9,
    reviews: 45,
    inStock: false,
    isNew: true,
  },
  {
    id: 'r11',
    brand: '智元机器人',
    brandEn: 'AgiBot',
    model: 'A2-W',
    category: 'robot',
    price: '¥420,000',
    priceUSD: '$58,000',
    badge: '🇨🇳 国产精品',
    badgeColor: '#FF6B35',
    img: 'https://readdy.ai/api/search-image?query=AgiBot%20humanoid%20robot%20white%20silver%20Chinese%20brand%20design%20standing%20pose%20clean%20white%20background%20professional%20product%20photography%20ultra%20realistic%208k&width=400&height=500&seq=robot-agibot-001&orientation=portrait',
    desc: '智元A2-W国产高端人形机器人，搭载自研灵巧手与全身力控系统，已在汽车工厂批量应用，性价比极高',
    specs: ['灵巧手', '全身力控', '汽车工厂', '国产芯片'],
    link: 'https://www.agibot.com',
    rating: 4.7,
    reviews: 189,
    inStock: true,
    isNew: true,
  },
  {
    id: 'r12',
    brand: '宇树科技',
    brandEn: 'Unitree',
    model: 'Go2 Pro',
    category: 'robot',
    price: '¥29,900',
    priceUSD: '$4,150',
    badge: '💎 入门首选',
    badgeColor: '#00FFCC',
    img: 'https://readdy.ai/api/search-image?query=Unitree%20Go2%20robot%20dog%20quadruped%20small%20compact%20design%20black%20yellow%20clean%20white%20background%20professional%20product%20photography%20ultra%20realistic%208k&width=400&height=500&seq=robot-go2-001&orientation=portrait',
    desc: '宇树Go2 Pro消费级四足机器人，搭载4D激光雷达与AI语音交互，是最适合家庭与开发者的入门级机器人',
    specs: ['4D激光雷达', 'AI语音', '续航 2h', '开发者友好'],
    link: 'https://www.unitree.com/go2',
    rating: 4.8,
    reviews: 1024,
    inStock: true,
    isNew: false,
  },
  {
    id: 'r13',
    brand: 'Apptronik',
    brandEn: 'Apptronik',
    model: 'Apollo',
    category: 'robot',
    price: '¥1,080,000',
    priceUSD: '$150,000',
    badge: '🚀 NASA认证',
    badgeColor: '#A855F7',
    img: 'https://readdy.ai/api/search-image?query=Apptronik%20Apollo%20humanoid%20robot%20white%20blue%20design%20standing%20pose%20NASA%20certified%20clean%20white%20background%20professional%20product%20photography%20ultra%20realistic%208k&width=400&height=500&seq=robot-apollo-001&orientation=portrait',
    desc: 'Apptronik Apollo由NASA前工程师团队打造，具备超强的环境适应能力，已通过NASA太空任务认证',
    specs: ['NASA认证', '负重 25kg', '太空级', '极端环境'],
    link: 'https://apptronik.com',
    rating: 4.8,
    reviews: 67,
    inStock: false,
    isNew: false,
  },
  {
    id: 'r14',
    brand: '宇树科技',
    brandEn: 'Unitree',
    model: 'H1 Dance Edition',
    category: 'robot',
    price: '¥1,200,000',
    priceUSD: '$167,000',
    badge: '💃 舞蹈版',
    badgeColor: '#FF6B9D',
    img: 'https://readdy.ai/api/search-image?query=Unitree%20H1%20humanoid%20robot%20dancing%20pose%20dynamic%20movement%20colorful%20stage%20lighting%20entertainment%20clean%20white%20background%20professional%20product%20photography%20ultra%20realistic%208k&width=400&height=500&seq=robot-h1dance-001&orientation=portrait',
    desc: '宇树H1舞蹈特别版，专为表演与娱乐场景优化，内置200套舞蹈动作库，可实时跟随音乐节拍起舞',
    specs: ['200套舞蹈', '音乐同步', '表演级', '全彩LED'],
    link: 'https://www.unitree.com/h1',
    rating: 5.0,
    reviews: 43,
    inStock: true,
    isNew: true,
  },
  {
    id: 'r15',
    brand: 'Neura Robotics',
    brandEn: 'Neura',
    model: '4NE-1',
    category: 'robot',
    price: '¥2,100,000',
    priceUSD: '$292,000',
    badge: '🧬 认知AI',
    badgeColor: '#FFD700',
    img: 'https://readdy.ai/api/search-image?query=Neura%20Robotics%204NE-1%20humanoid%20robot%20white%20silver%20cognitive%20AI%20design%20standing%20pose%20clean%20white%20background%20professional%20product%20photography%20ultra%20realistic%208k&width=400&height=500&seq=robot-neura-001&orientation=portrait',
    desc: 'Neura Robotics 4NE-1搭载认知AI系统，具备真正的情境理解与长期记忆能力，是欧洲最先进的人形机器人',
    specs: ['认知AI', '长期记忆', '情境理解', '欧洲制造'],
    link: 'https://neura-robotics.com',
    rating: 4.9,
    reviews: 38,
    inStock: false,
    isNew: true,
  },
];

const META_ITEMS = [
  {
    id: 'm1',
    brand: 'Apple',
    model: 'Vision Pro 2',
    category: 'meta',
    price: '¥29,999',
    priceUSD: '$4,199',
    badge: '🍎 苹果生态',
    badgeColor: '#A855F7',
    img: 'https://readdy.ai/api/search-image?query=Apple%20Vision%20Pro%202%20mixed%20reality%20headset%20sleek%20design%20white%20silver%20clean%20white%20background%20professional%20product%20photography%20ultra%20realistic%208k&width=400&height=400&seq=meta-visionpro-001&orientation=squarish',
    desc: 'Apple Vision Pro 2，搭载M4芯片与全新空间计算系统，分辨率提升50%，重量减轻30%，是最顶级的XR体验设备',
    specs: ['M4芯片', '8K分辨率', '空间计算', '眼动追踪'],
    link: 'https://www.apple.com/apple-vision-pro',
    rating: 4.9,
    reviews: 2048,
    inStock: true,
    isNew: true,
  },
  {
    id: 'm2',
    brand: 'Meta',
    model: 'Quest 4 Pro',
    category: 'meta',
    price: '¥6,999',
    priceUSD: '$999',
    badge: '🌐 元宇宙入口',
    badgeColor: '#00FFCC',
    img: 'https://readdy.ai/api/search-image?query=Meta%20Quest%204%20Pro%20VR%20headset%20black%20sleek%20design%20clean%20white%20background%20professional%20product%20photography%20ultra%20realistic%208k&width=400&height=400&seq=meta-quest4-001&orientation=squarish',
    desc: 'Meta Quest 4 Pro，搭载Snapdragon XR4芯片，支持全彩透视与AI场景理解，是性价比最高的元宇宙入口设备',
    specs: ['XR4芯片', '全彩透视', 'AI场景', '120Hz刷新'],
    link: 'https://www.meta.com/quest',
    rating: 4.7,
    reviews: 5632,
    inStock: true,
    isNew: true,
  },
  {
    id: 'm3',
    brand: 'Neuralink',
    model: 'N2 脑机接口',
    category: 'wearable',
    price: '¥188,000',
    priceUSD: '$26,000',
    badge: '🧠 意念控制',
    badgeColor: '#FF6B9D',
    img: 'https://readdy.ai/api/search-image?query=Neuralink%20brain%20computer%20interface%20neural%20chip%20implant%20device%20futuristic%20medical%20technology%20clean%20white%20background%20professional%20product%20photography%20ultra%20realistic%208k&width=400&height=400&seq=meta-neuralink-001&orientation=squarish',
    desc: 'Neuralink N2脑机接口，马斯克旗下神经科技公司最新产品，可实现意念控制数字设备，已获FDA批准临床应用',
    specs: ['FDA认证', '意念控制', '1024电极', '无线传输'],
    link: 'https://neuralink.com',
    rating: 4.8,
    reviews: 156,
    inStock: false,
    isNew: true,
  },
  {
    id: 'm4',
    brand: 'META66',
    model: 'MetaLand 数字土地',
    category: 'digital',
    price: '¥50,000起',
    priceUSD: '$6,950+',
    badge: '🏝️ 数字地产',
    badgeColor: '#FFD700',
    img: 'https://readdy.ai/api/search-image?query=metaverse%20digital%20land%20NFT%20virtual%20real%20estate%20holographic%20city%20plot%20glowing%20neon%20dark%20background%20futuristic%203D%20render%20vibrant%20colorful&width=400&height=400&seq=meta-land-001&orientation=squarish',
    desc: 'META66元宇宙数字土地，位于核心商业区，支持建造虚拟建筑、举办活动、开展商业运营，永久产权NFT认证',
    specs: ['永久产权', 'NFT认证', '核心地段', '商业运营'],
    link: '/digital-assets',
    rating: 4.6,
    reviews: 389,
    inStock: true,
    isNew: false,
  },
  {
    id: 'm5',
    brand: 'XREAL',
    model: 'Air 3 Ultra',
    category: 'meta',
    price: '¥4,999',
    priceUSD: '$699',
    badge: '👓 轻量AR',
    badgeColor: '#00FF88',
    img: 'https://readdy.ai/api/search-image?query=XREAL%20Air%20AR%20glasses%20lightweight%20sleek%20design%20transparent%20lenses%20clean%20white%20background%20professional%20product%20photography%20ultra%20realistic%208k&width=400&height=400&seq=meta-xreal-001&orientation=squarish',
    desc: 'XREAL Air 3 Ultra轻量AR眼镜，重量仅72g，支持空间计算与3D显示，是最适合日常佩戴的AR设备',
    specs: ['重量 72g', '空间计算', '3D显示', '全天候'],
    link: 'https://www.xreal.com',
    rating: 4.7,
    reviews: 1876,
    inStock: true,
    isNew: true,
  },
  {
    id: 'm6',
    brand: 'META66',
    model: '元宇宙身份NFT',
    category: 'digital',
    price: '¥9,900',
    priceUSD: '$1,380',
    badge: '🎭 数字身份',
    badgeColor: '#FF6B9D',
    img: 'https://readdy.ai/api/search-image?query=NFT%20digital%20identity%20avatar%20metaverse%20holographic%20character%20glowing%20neon%20dark%20background%20futuristic%203D%20render%20vibrant%20colorful%20unique&width=400&height=400&seq=meta-nft-001&orientation=squarish',
    desc: 'META66元宇宙身份NFT，限量10000个，持有者享有元宇宙VIP权益、治理投票权与专属空间访问权',
    specs: ['限量10000', 'VIP权益', '治理投票', '专属空间'],
    link: '/digital-assets',
    rating: 4.8,
    reviews: 567,
    inStock: true,
    isNew: false,
  },
];

const ALL_PRODUCTS = [...ROBOTS, ...META_ITEMS];

interface CartItem {
  id: string;
  model: string;
  brand: string;
  price: string;
  img: string;
  qty: number;
}

export default function MetaShop() {
  const { ref: sectionRef, isVisible } = useScrollAnimation();
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState('all');
  const [cart, setCart] = useState<CartItem[]>([]);
  const [showCart, setShowCart] = useState(false);
  const [addedId, setAddedId] = useState<string | null>(null);
  const [hoveredId, setHoveredId] = useState<string | null>(null);
  const scrollRef = useRef<HTMLDivElement>(null);

  const filtered = activeCategory === 'all'
    ? ALL_PRODUCTS
    : ALL_PRODUCTS.filter(p => p.category === activeCategory);

  const addToCart = (product: typeof ALL_PRODUCTS[0]) => {
    setCart(prev => {
      const existing = prev.find(i => i.id === product.id);
      if (existing) return prev.map(i => i.id === product.id ? { ...i, qty: i.qty + 1 } : i);
      return [...prev, { id: product.id, model: product.model, brand: product.brand, price: product.price, img: product.img, qty: 1 }];
    });
    setAddedId(product.id);
    setTimeout(() => setAddedId(null), 1500);
  };

  const removeFromCart = (id: string) => {
    setCart(prev => prev.filter(i => i.id !== id));
  };

  const totalItems = cart.reduce((sum, i) => sum + i.qty, 0);

  return (
    <section
      id="meta-shop"
      ref={sectionRef as React.RefObject<HTMLElement>}
      className="relative py-20 overflow-hidden"
      style={{ background: 'linear-gradient(180deg, #020810 0%, #050d1a 50%, #020810 100%)' }}
    >
      {/* Background */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute inset-0 opacity-20">
          <img
            src="https://readdy.ai/api/search-image?query=futuristic%20metaverse%20shopping%20mall%20holographic%20displays%20neon%20lights%20dark%20space%20background%20luxury%20tech%20store%20cyberpunk%20aesthetic%20ultra%20wide%20cinematic%208k%20vibrant%20colors&width=1920&height=1080&seq=shop-bg-001&orientation=landscape"
            alt=""
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#020810]/80 via-[#020810]/40 to-[#020810]/90" />
        </div>
        {/* Grid lines */}
        <div className="absolute inset-0 opacity-5" style={{
          backgroundImage: 'linear-gradient(rgba(0,255,204,0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(0,255,204,0.3) 1px, transparent 1px)',
          backgroundSize: '60px 60px',
        }} />
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6">
        {/* Header */}
        <div className={`text-center mb-12 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`}>
          <div className="inline-flex items-center gap-3 px-6 py-2 rounded-full border mb-6" style={{ borderColor: 'rgba(0,255,204,0.4)', background: 'rgba(0,255,204,0.08)' }}>
            <span className="w-2 h-2 rounded-full bg-[#00FFCC] animate-pulse" />
            <span className="text-sm font-medium text-[#00FFCC]" style={{ fontFamily: 'Orbitron, sans-serif', letterSpacing: '0.1em' }}>META SHOP · 元宇宙超级商城</span>
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-white mb-4" style={{ fontFamily: 'Orbitron, sans-serif' }}>
            未来科技
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#00FFCC] via-[#FFD700] to-[#FF6B35]"> 购物中心</span>
          </h2>
          <p className="text-white/50 text-base max-w-2xl mx-auto leading-relaxed">
            汇聚全球15+顶级机器人品牌 · 元宇宙装备 · 数字资产 · 智能穿戴
            <br />
            <span className="text-[#00FFCC]/70 text-sm">全球最前沿的科技产品，一站式购齐</span>
          </p>

          {/* Cart button */}
          <button
            onClick={() => setShowCart(true)}
            className="mt-6 inline-flex items-center gap-3 px-6 py-3 rounded-full font-bold text-sm transition-all hover:scale-105 cursor-pointer whitespace-nowrap"
            style={{ background: 'rgba(0,255,204,0.15)', border: '1.5px solid rgba(0,255,204,0.4)', color: '#00FFCC' }}
          >
            <i className="ri-shopping-cart-2-line text-lg" />
            购物车
            {totalItems > 0 && (
              <span className="w-6 h-6 flex items-center justify-center rounded-full text-xs font-black text-black" style={{ background: '#00FFCC' }}>
                {totalItems}
              </span>
            )}
          </button>
        </div>

        {/* Category Filter */}
        <div className={`flex flex-wrap gap-3 justify-center mb-10 transition-all duration-1000 delay-200 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          {CATEGORIES.map(cat => (
            <button
              key={cat.id}
              onClick={() => setActiveCategory(cat.id)}
              className="flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold transition-all duration-300 cursor-pointer whitespace-nowrap"
              style={{
                background: activeCategory === cat.id ? `${cat.color}20` : 'rgba(255,255,255,0.04)',
                border: `1.5px solid ${activeCategory === cat.id ? cat.color + '60' : 'rgba(255,255,255,0.1)'}`,
                color: activeCategory === cat.id ? cat.color : 'rgba(255,255,255,0.5)',
                boxShadow: activeCategory === cat.id ? `0 0 20px ${cat.color}20` : 'none',
              }}
            >
              <i className={`${cat.icon} text-sm`} />
              {cat.label}
              <span className="text-xs opacity-60">
                ({cat.id === 'all' ? ALL_PRODUCTS.length : ALL_PRODUCTS.filter(p => p.category === cat.id).length})
              </span>
            </button>
          ))}
        </div>

        {/* Products Grid */}
        <div
          ref={scrollRef}
          className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 transition-all duration-1000 delay-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          {filtered.map((product) => {
            const isHovered = hoveredId === product.id;
            const isAdded = addedId === product.id;
            return (
              <div
                key={product.id}
                className="group relative rounded-2xl overflow-hidden transition-all duration-400 cursor-pointer"
                style={{
                  background: 'rgba(255,255,255,0.03)',
                  border: isHovered ? `1.5px solid ${product.badgeColor}50` : '1px solid rgba(255,255,255,0.08)',
                  transform: isHovered ? 'translateY(-6px)' : 'none',
                  boxShadow: isHovered ? `0 20px 40px ${product.badgeColor}15` : 'none',
                }}
                onMouseEnter={() => setHoveredId(product.id)}
                onMouseLeave={() => setHoveredId(null)}
              >
                {/* Product Image */}
                <div className="relative overflow-hidden" style={{ height: '220px' }}>
                  <img
                    src={product.img}
                    alt={product.model}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />

                  {/* Badge */}
                  <div
                    className="absolute top-3 left-3 px-2.5 py-1 rounded-full text-xs font-bold whitespace-nowrap"
                    style={{ background: `${product.badgeColor}25`, border: `1px solid ${product.badgeColor}50`, color: product.badgeColor, backdropFilter: 'blur(8px)' }}
                  >
                    {product.badge}
                  </div>

                  {/* New tag */}
                  {product.isNew && (
                    <div className="absolute top-3 right-3 px-2 py-0.5 rounded-full text-xs font-bold" style={{ background: '#00FFCC', color: '#000' }}>
                      NEW
                    </div>
                  )}

                  {/* Stock status */}
                  {!product.inStock && (
                    <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
                      <span className="px-4 py-2 rounded-full text-sm font-bold text-white" style={{ background: 'rgba(255,107,53,0.8)', border: '1px solid rgba(255,107,53,0.6)' }}>
                        预售中
                      </span>
                    </div>
                  )}
                </div>

                {/* Product Info */}
                <div className="p-4">
                  <div className="flex items-start justify-between mb-2">
                    <div>
                      <p className="text-white/40 text-xs mb-0.5">{product.brand}</p>
                      <h3 className="text-white font-bold text-sm leading-tight">{product.model}</h3>
                    </div>
                    <div className="text-right flex-shrink-0 ml-2">
                      <p className="text-[#00FFCC] font-black text-sm whitespace-nowrap" style={{ fontFamily: 'Orbitron, sans-serif' }}>{product.price}</p>
                      <p className="text-white/30 text-xs">{product.priceUSD}</p>
                    </div>
                  </div>

                  {/* Rating */}
                  <div className="flex items-center gap-2 mb-3">
                    <div className="flex items-center gap-0.5">
                      {[1,2,3,4,5].map(i => (
                        <i key={i} className={i <= Math.floor(product.rating) ? 'ri-star-fill text-xs' : 'ri-star-line text-xs'} style={{ color: '#FFD700' }} />
                      ))}
                    </div>
                    <span className="text-white/40 text-xs">{product.rating} ({product.reviews})</span>
                  </div>

                  {/* Specs */}
                  <div className="flex flex-wrap gap-1 mb-4">
                    {product.specs.slice(0, 3).map(spec => (
                      <span key={spec} className="px-2 py-0.5 rounded-full text-xs" style={{ background: 'rgba(255,255,255,0.06)', color: 'rgba(255,255,255,0.5)', border: '1px solid rgba(255,255,255,0.08)' }}>
                        {spec}
                      </span>
                    ))}
                  </div>

                  {/* Action Buttons */}
                  <div className="flex gap-2">
                    <a
                      href={product.link}
                      target={product.link.startsWith('http') ? '_blank' : '_self'}
                      rel="noopener noreferrer"
                      className="flex-1 flex items-center justify-center gap-1.5 py-2 rounded-xl text-xs font-semibold transition-all whitespace-nowrap cursor-pointer"
                      style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.12)', color: 'rgba(255,255,255,0.7)' }}
                      onClick={e => { if (!product.link.startsWith('http')) { e.preventDefault(); navigate(product.link); } }}
                    >
                      <i className="ri-external-link-line text-xs" />
                      详情
                    </a>
                    <button
                      onClick={() => addToCart(product)}
                      disabled={!product.inStock}
                      className="flex-1 flex items-center justify-center gap-1.5 py-2 rounded-xl text-xs font-bold transition-all whitespace-nowrap cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                      style={{
                        background: isAdded ? '#00FF88' : product.inStock ? `${product.badgeColor}25` : 'rgba(255,255,255,0.05)',
                        border: `1px solid ${isAdded ? '#00FF88' : product.inStock ? product.badgeColor + '50' : 'rgba(255,255,255,0.1)'}`,
                        color: isAdded ? '#000' : product.inStock ? product.badgeColor : 'rgba(255,255,255,0.3)',
                      }}
                    >
                      <i className={`${isAdded ? 'ri-check-line' : 'ri-add-circle-line'} text-xs`} />
                      {isAdded ? '已加入' : product.inStock ? '加入购物车' : '预约'}
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* View All Button */}
        <div className="text-center mt-10 flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={() => navigate('/shop')}
            className="inline-flex items-center gap-3 px-10 py-4 rounded-full font-bold text-base transition-all hover:scale-105 cursor-pointer whitespace-nowrap"
            style={{
              background: 'linear-gradient(135deg, rgba(0,255,204,0.2), rgba(255,107,53,0.2))',
              border: '1.5px solid rgba(0,255,204,0.4)',
              color: '#00FFCC',
              boxShadow: '0 0 30px rgba(0,255,204,0.15)',
            }}
          >
            <i className="ri-store-3-line text-lg" />
            进入完整元宇宙商城
            <i className="ri-arrow-right-line" />
          </button>
          <button
            onClick={() => navigate('/omniverse-mall')}
            className="inline-flex items-center gap-3 px-10 py-4 rounded-full font-bold text-base transition-all hover:scale-105 cursor-pointer whitespace-nowrap"
            style={{
              background: 'linear-gradient(135deg, rgba(255,215,0,0.2), rgba(255,64,129,0.2))',
              border: '1.5px solid rgba(255,215,0,0.5)',
              color: '#FFD700',
              boxShadow: '0 0 30px rgba(255,215,0,0.2)',
            }}
          >
            <i className="ri-planet-line text-lg" />
            NEXUS OMNI MALL · 星际商城
            <i className="ri-arrow-right-line" />
          </button>
        </div>

        {/* NEXUS OMNI MALL Banner */}
        <div
          className="mt-12 rounded-3xl overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-2"
          onClick={() => navigate('/omniverse-mall')}
          style={{ border: '2px solid rgba(255,215,0,0.3)', boxShadow: '0 0 60px rgba(255,215,0,0.1)' }}
        >
          <div className="relative overflow-hidden" style={{ height: '280px' }}>
            <img
              src="https://readdy.ai/api/search-image?query=futuristic%20metaverse%20shopping%20mall%20holographic%20displays%20floating%20products%20neon%20lights%20dark%20space%20background%20ultra%20wide%20cinematic%20sci-fi%20luxury%20retail%20experience%20golden%20orange%20glow%208k%20ultra%20detailed%20immersive&width=1600&height=500&seq=mall-banner-home-v3&orientation=landscape"
              alt="NEXUS OMNI MALL"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0" style={{ background: 'linear-gradient(to right, rgba(1,2,8,0.9) 0%, rgba(1,2,8,0.5) 50%, rgba(1,2,8,0.3) 100%)' }} />
            <div className="absolute inset-0 flex items-center px-10">
              <div>
                <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full mb-4" style={{ background: 'rgba(255,215,0,0.15)', border: '1px solid rgba(255,215,0,0.4)' }}>
                  <i className="ri-store-3-line text-xs" style={{ color: '#FFD700' }} />
                  <span className="text-xs font-black" style={{ color: '#FFD700', fontFamily: 'Orbitron, sans-serif' }}>NEXUS OMNI MALL · 全新开业</span>
                </div>
                <h3 className="text-4xl font-black text-white mb-2" style={{ fontFamily: 'Orbitron, sans-serif' }}>
                  <span style={{ background: 'linear-gradient(90deg, #FFD700, #FF6B35)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>星际元宇宙商城</span>
                </h3>
                <p className="text-white/55 text-base mb-2">购未来，在星际 · 500+未来商品 · VR/AR/裸眼3D沉浸购物</p>
                <p className="text-white/35 text-sm mb-6">无人机直送 · AETHER GLOBE跨洲气球 · 月球火星实时画面</p>
                <div className="flex flex-wrap gap-3">
                  {[
                    { v: '20+', l: '商品品类', c: '#FFD700' },
                    { v: '500+', l: '未来商品', c: '#FF6B9D' },
                    { v: '8D', l: '沉浸体验', c: '#00FFCC' },
                    { v: '∞', l: '星际物流', c: '#FF6B35' },
                  ].map(s => (
                    <div key={s.l} className="flex items-center gap-1.5 px-3 py-1.5 rounded-xl" style={{ background: `${s.c}15`, border: `1px solid ${s.c}30` }}>
                      <span className="font-black text-base" style={{ color: s.c, fontFamily: 'Orbitron, sans-serif' }}>{s.v}</span>
                      <span className="text-xs" style={{ color: 'rgba(255,255,255,0.4)' }}>{s.l}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="absolute right-10 top-1/2 -translate-y-1/2">
              <div className="flex items-center gap-3 px-6 py-3 rounded-2xl font-black text-sm" style={{ background: 'linear-gradient(135deg, #FFD700, #FF6B35)', color: '#000', fontFamily: 'Orbitron, sans-serif', boxShadow: '0 0 30px rgba(255,215,0,0.4)' }}>
                <i className="ri-store-3-line" />
                立即进入
                <i className="ri-arrow-right-line" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Cart Drawer */}
      {showCart && (
        <div className="fixed inset-0 z-[200] flex">
          <div className="flex-1 bg-black/60 backdrop-blur-sm" onClick={() => setShowCart(false)} />
          <div
            className="w-full max-w-md flex flex-col"
            style={{ background: '#0a0f1e', borderLeft: '1px solid rgba(0,255,204,0.2)' }}
          >
            <div className="flex items-center justify-between p-6 border-b" style={{ borderColor: 'rgba(0,255,204,0.15)' }}>
              <h3 className="text-white font-bold text-lg flex items-center gap-2" style={{ fontFamily: 'Orbitron, sans-serif' }}>
                <i className="ri-shopping-cart-2-line text-[#00FFCC]" />
                购物车 ({totalItems})
              </h3>
              <button onClick={() => setShowCart(false)} className="w-8 h-8 flex items-center justify-center rounded-full cursor-pointer" style={{ background: 'rgba(255,255,255,0.08)', color: 'rgba(255,255,255,0.6)' }}>
                <i className="ri-close-line" />
              </button>
            </div>

            <div className="flex-1 overflow-y-auto p-6 space-y-4">
              {cart.length === 0 ? (
                <div className="text-center py-16">
                  <i className="ri-shopping-cart-line text-5xl text-white/20 block mb-4" />
                  <p className="text-white/40 text-sm">购物车是空的</p>
                  <p className="text-white/20 text-xs mt-1">去挑选你心仪的未来科技产品吧</p>
                </div>
              ) : (
                cart.map(item => (
                  <div key={item.id} className="flex gap-3 p-3 rounded-xl" style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)' }}>
                    <img src={item.img} alt={item.model} className="w-16 h-16 rounded-lg object-cover flex-shrink-0" />
                    <div className="flex-1 min-w-0">
                      <p className="text-white/50 text-xs">{item.brand}</p>
                      <p className="text-white font-semibold text-sm truncate">{item.model}</p>
                      <p className="text-[#00FFCC] font-bold text-sm mt-1" style={{ fontFamily: 'Orbitron, sans-serif' }}>{item.price}</p>
                    </div>
                    <div className="flex flex-col items-end gap-2">
                      <button onClick={() => removeFromCart(item.id)} className="w-6 h-6 flex items-center justify-center rounded-full cursor-pointer" style={{ background: 'rgba(255,107,53,0.2)', color: '#FF6B35' }}>
                        <i className="ri-delete-bin-line text-xs" />
                      </button>
                      <span className="text-white/60 text-xs">x{item.qty}</span>
                    </div>
                  </div>
                ))
              )}
            </div>

            {cart.length > 0 && (
              <div className="p-6 border-t" style={{ borderColor: 'rgba(0,255,204,0.15)' }}>
                <button
                  onClick={() => navigate('/shop')}
                  className="w-full py-4 rounded-xl font-bold text-base transition-all hover:scale-105 cursor-pointer whitespace-nowrap"
                  style={{ background: 'linear-gradient(135deg, #00FFCC, #00CC99)', color: '#000', fontFamily: 'Orbitron, sans-serif', fontSize: '0.85rem' }}
                >
                  <i className="ri-secure-payment-line mr-2" />
                  前往结算
                </button>
                <p className="text-white/30 text-xs text-center mt-3">点击详情按钮跳转至品牌官网完成购买</p>
              </div>
            )}
          </div>
        </div>
      )}
    </section>
  );
}
